var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "signPlanFormRef" },
        [
          _c("validation-provider", {
            attrs: { rules: "required|validOption" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function({ errors }) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex flex-column flex-md-row align-items-start align-items-md-center border-bottom"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex-grow-1" },
                          [
                            _vm._v(" " + _vm._s(_vm.questionLabel) + " "),
                            errors[0]
                              ? _c("custom-error", {
                                  staticClass: "ml-n1",
                                  attrs: {
                                    message: "Favor de seleccionar una opción.",
                                    variant: "no-border"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _c("custom-radio", {
                          ref: "question",
                          staticClass: "custom-radio__extended mt-3 mt-md-0",
                          attrs: {
                            "change-event": _vm.handleChangeEventOption,
                            "container-class": "custom-radio-center",
                            "custom-error-msg": "''",
                            disabled: _vm.disabled,
                            "is-question-list": "",
                            name: "question-1",
                            options: _vm.mechanismOptions
                          },
                          model: {
                            value: _vm.questionAnswer,
                            callback: function($$v) {
                              _vm.questionAnswer = $$v
                            },
                            expression: "questionAnswer"
                          }
                        })
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }